<template>
 <div class="title">
   <slot/>
 </div>
</template>
<script>

export default {
  name: 'Title'
}

</script>
